import { lazy } from 'react';

const LotteriesRoutes = [
  {
    path: 'lotteries',
    component: lazy(() => import('views/lotteries')),
  },
];

export default LotteriesRoutes;
